export default "__VITE_ASSET__0b2d438a__"